import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, empty } from 'rxjs';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { catchError, map } from 'rxjs/operators';
import { BaseResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LiteratureService {

  constructor(private httpClient: HttpClient) { }
  public getLieratureDocumentsPages(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.LITERATURE.GET_LITERATURE_DOCUMENT_PAGES}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  } 
  public getLieratureDetails(body:any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.LITERATURE.GET_LITERATURE_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getLieratureDetailsAdmin(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.LITERATURE.GET_LITERATURE_DETAILS_ADMIN}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public approveDocument(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.LITERATURE.APPROVE_DOCUMENT_ADMIN}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public downloadFiles(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.LITERATURE.DOWNLOAD_FILE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public downloadFilesLiterature(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.LITERATURE.DOWNLOAD_FILE}`;
    return ApiService.genericObservablePostWithOptions(this.httpClient, endPoint, body, {
      responseType: 'blob',
      observe: 'body'
    }).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: any) => response) // response is a Blob
    );
  }
}
